class Preferences
{
    constructor() {
        this._setPreferencesIfDoesntExist();

        let preferences = JSON.parse(localStorage.getItem("_preferences"));
        this._theme = preferences.theme;
    }

    /**
     * Set the default preferences if it doesn't exist.
     * 
     * @return {void}
     */
    _setPreferencesIfDoesntExist()
    {
        if(!this._exists()) {
            this._theme = "light";
            this.save();
        }
    }

    /**
     * Check if the preferences exists.
     * 
     * @return {Boolean}
     */
    _exists()
    {
        let preferences = localStorage.getItem("_preferences");
        return preferences !== null && preferences !== undefined && preferences.trim() !== "";
    }

    /**
     * Update the preferences by saving to the local storage.
     */
    save()
    {
        let preferences = {
            theme: this._theme,
        }
        localStorage.setItem("_preferences", JSON.stringify(preferences));
    }

    /**
     * Set the theme.
     * 
     * @param {String} theme
     * 
     * @return {Locale}
     */
    setTheme(theme)
    {
        this._theme = theme;
        return this;
    }

    /**
     * Get the theme.
     * 
     * @return {String}
     */
    getTheme()
    {
        return this._theme;
    }
}

export default Preferences;